import { create, tsx } from '@dojo/framework/core/vdom';

import LinkButton from './LinkButton';

export interface ConnectButtonProperties {
	/**
	 * undefined: use on light colored backgrounds;
	 * on-dark: use on dark colored backgrounds;
	 * on-medium: use on medium colored backgrounds
	 */
	color?: 'on-dark' | 'on-medium';

	/**
	 * A custom route for the connect button, default 'contact'
	 */
	to?: string;
}

const factory = create().properties<ConnectButtonProperties>();

export const ConnectButton = factory(function ConnectButton({ properties }) {
	const { color, to = 'contact' } = properties();

	return (
		<LinkButton color={color} to={to}>
			Let's connect
		</LinkButton>
	);
});

export default ConnectButton;
